import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Menu, message } from 'antd';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { intl } from 'components/GlobalProvider';
import { ListCellText } from 'certn-ui/List';
import { getUserMode } from 'base/BaseSelectors';
import { fetchReportPDF as fetchHRReportPDF } from 'views/manager/views/hr/views/applications/ApplicationsActions';
import { fetchReportPDF as fetchPMReportPDF } from 'views/manager/views/pm/views/applications/ApplicationsActions';

const ItemDownloadPDFReport = ({ applicantId, ...rest }) => {
    const dispatch = useDispatch();
    const userMode = useSelector(getUserMode);

    const downloadReport = async () => {
        try {
            if (userMode === 'HR') await dispatch(fetchHRReportPDF({ applicantId }));
            else await dispatch(fetchPMReportPDF(applicantId));
            message.success(
                intl.formatMessage({
                    id: '004e5.StatusDropdown.reportPDFDownloaded',
                    defaultMessage: 'PDF report downloaded.',
                })
            );
        } catch (error) {
            message.error(
                intl.formatMessage({
                    id: '004e5.StatusDropdown.reportPDFDownloadFailed',
                    defaultMessage: 'Failed to fetch PDF report.',
                })
            );
        }
    };

    return (
        <Menu.Item {...rest}>
            <ListCellText clickable onClick={downloadReport} data-testid="download-pdf-report">
                <FormattedMessage id="004ed.StatusDropdown.downloadPDFReport" defaultMessage="Download PDF Report" />
            </ListCellText>
        </Menu.Item>
    );
};

ItemDownloadPDFReport.propTypes = {
    applicantId: PropTypes.string.isRequired,
};

export default ItemDownloadPDFReport;
